import { defineNuxtPlugin } from "#app";
import VueLazyLoad from "vue3-lazyload";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueLazyLoad, {
    // 기본 옵션 예시
    // loading: "/images/loading-spinner.gif", // 로딩 중 표시할 이미지
    // error: "/images/error-icon.png", // 로드 실패 시 표시할 이미지
    // preLoad: 1.3, // 뷰포트보다 얼마나 빨리 미리 로드할지
    // attempt: 2, // 실패 시 재시도 횟수
  });
});
